// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"if_a bhf_ji","CommentListPlaceholder--Legacy":"if_b bhf_ra bhf_wo"};